import { Plane } from "lucide-react";

const ITEMS = [
  { text: "Uma boa viagem começa muito antes do embarque.", cls: "font-serif italic font-medium" },
  { text: "SEU PRÓXIMO CAPÍTULO", cls: "font-mono tracking-[0.3em] text-sm" },
  { text: "ENCONTRE SUA PRÓXIMA VIAGEM", cls: "font-display font-extrabold tracking-tight" },
];

function Sequence() {
  return (
    <div className="flex items-center shrink-0">
      {Array.from({ length: 3 }).map((_, r) =>
        ITEMS.map((item, i) => (
          <span key={`${r}-${i}`} className="flex items-center shrink-0">
            <span className={`text-white text-lg sm:text-xl px-8 whitespace-nowrap ${item.cls}`}>{item.text}</span>
            <Plane size={18} className="text-white/70 shrink-0" />
          </span>
        ))
      )}
    </div>
  );
}

export default function Marquee() {
  return (
    <section data-testid="editorial-marquee" aria-hidden="true" className="relative bg-[#0B1120] py-10 overflow-hidden">
      <div className="-rotate-1 scale-[1.03] bg-[#FF5A36] py-4 overflow-hidden shadow-[0_20px_60px_-15px_rgba(255,90,54,0.5)]">
        <div className="flex w-max animate-marquee">
          <Sequence />
          <Sequence />
        </div>
      </div>
    </section>
  );
}
